﻿let _ = require('lodash');
let URI = require('urijs');
let Q = require('q');
let uuid = require('uuid');
require('../jssocials.min.js');

let DonationLevels = require('../DonationLevels');
let BillingInformation = require('./BillingInformation');
let PaymentInfo = require('./PaymentInfo');
let ThankYouMessage = require('./ThankYouMessage');
let LuminateSession = require('../LuminateSession');
let DonationDetailsRepository = require('./DonationDetailsRepository');
let Tracker = require('../Tracking/Tracker');
let PaymentMethods = require('./PaymentMethods');
//let trackVirtualPageView = require('../Tracking/Tracker').trackVirtualPageView;

const SCREENS = {
    DONATION_LEVEL: 'amount',
    PAYMENT_INFO: 'payment',
    BILLING_INFO: 'donorinfo',
    SUMMARY: 'thankyou',
};

module.exports = FullDonationForm;

function FullDonationForm({form}) {
    let params = URI.parseQuery(window.location.search);

    let giftInMemoryOf = $('.in-memory-of');
    let formID = params.formId || $('.donate-form-wrapper').attr('data-formID');
    let selectGiftDuration = $('.select-gift-duration');
    let makeSelectionWindow = $('.make-selection');
    let errorField = $('.error-field .error-text');
    let nextButton = $('#next-button');
    let goBackButton = $('#back-button');
    let successMessage = $('#thank-you-message');
    let selectDonateForm = $('#select-amount-form');
    let honoreeData = $('#honoree-data-form .honoree-data');
    let honoreeInputField = $('#honoree-data-form #honoree');
    let inHonorOf = $('#in-honor-of');
    let inMemoryOf = $('#in-memory-of');
    let once = $('.once-monthly #once');
    let monthly = $('.once-monthly #monthly');
    let tributeType = 'memory';
    let chooseDesignations = $('#click-for-designations');
    let donationFormPicture = $('.fill-donate-form-picture');
    let printThankYouPage = $('.print-thank-you');
    let designasionItem = $("#designations-select-item");
    let designationItemArrow = $("#select-designation-item");
    let designationSelectedItem = $(".designations-selected-item");
    let billingForm1 = $('#billing-information');
    let billingNextButton1 = $('#billing-1-next-button');
    let previous1 = $('#billing-1-previous-button');
    let billingForm2 = $('#billing-personal-information');
    let donateButton = $('#billing-2-next-button');
    let previous2 = $('#billing-2-previous-button');
    let honoreeNext = $('#honoree-next-button');
    let cancelButton1 = $('#billing-1-cancel-button');
    let cancelButton2 = $('#billing-2-cancel-button');
    let inputLevel = $("li.donation-level > input.level-element");
    let buttonLevel = $("li.donation-level > button.level-element");
    let honoreForm = $(".honoree-data");

    if (params.donationId) {
        const repository = new DonationDetailsRepository(window.sessionStorage);
        const donationData = repository.get(params.donationId);
        finishDonation(params.donationId, donationData);
        hideLoadingOverlay();
        return;
    } else if (params.error) {
        errorField[0].innerHTML = 'There was a problem encountered while processing your donation. Please try again later.'
    }

    let donationFrequency = null;
    let sendingRequest = false;
    let currentScreen = null;
    switchScreen(SCREENS.DONATION_LEVEL);  
    
    let luminateConfig = {
        api_key: luminateClientApiConfig.ApiKey,
        v: luminateClientApiConfig.Version
    };

    let donationId = uuid.v4();
    let levelsContainer = form.find('.levels-container');
    let designationsContainer = form.find('.designations-list');
    let designationsList = form.find('.designations-list .designations');
    let designationsListItem = form.find('.designations-list .designations .list-element');
    let designations = designationsList.find('li'); 

    let donationLevels = new DonationLevels({
        formId: formID,
        levelsContainer: levelsContainer,
        designationsList: designationsList,
        designationsContainer: designationsContainer,
        luminateConfig: luminateConfig,
        selectedLevelId: params.levelId,
        selectedAmount: params.amount,
        selectFirstOption: false,
    });

    donationLevels.onAmountChange = amount => {
        Tracker.donationFormAmountClicked({
            formId: formID, 
            donationAmount: amount,
            preselectedAmoutChosen: donationLevels.isSelectedLevelPredefined()
        });
        form.find('.donation-amount').text(`Gift Amount $${amount}`);
    }

    donationLevels.onDesignationChange = designation => {
        Tracker.donationFormDesignationChange({
            formId: formID,
            designate: designation,
        });
    }

    let billingInfo = new BillingInformation({
        container: form.find('#billing-personal-information'),
        luminateConfig: luminateConfig,
    });

    let paymentInfo = new PaymentInfo({ $container: billingForm1, transactionId: donationId });

    Q.allSettled([
        donationLevels.initialize(),        
        billingInfo.fillBillingInformation()
    ]).finally(() => hideLoadingOverlay())
    .done();

    selectGiftDuration.on('click', function () {
        makeSelectionWindow.css('display', 'block');
    });

    once.on('click', function () {
        monthly.removeClass('selected');
        $(this).addClass('selected');
        donationFrequency = null;
    });

    monthly.on('click', function () {
        $(this).addClass('selected');
        donationFrequency = 'monthly';
        once.removeClass('selected');
    });

    $(".select-designation-item, .select-item-design").on('click', function(e){
        e.stopPropagation();
        Tracker.donationFormDesignateGiftOpened({ formId: formID });
        designationsList.toggle();
    }); 

    $(document).ready(function() {
        designationSelectedItem.css("display","none");
        $(document).on("click","li.list-element",function(){ 
            if($("li.list-element").hasClass('selected'))
            {
                $("div.designations-list > p").css('display', 'none');

                designasionItem.text($(this).text()); 
                designationSelectedItem.css("display","");
            }
            else{
                designationSelectedItem.css("display","none");
                designasionItem.text(''); 
                $("div.designations-list > p").css('display', "");
            }
        });
         
        $(document).on("click", ".select-designation-item, .select-item-design", function(e){
            e.stopPropagation();
            Tracker.donationFormDesignateGiftOpened({ formId: formID });
            designationsList.toggle();
        });

        $(document).on("click", "button.level-element", function() {             
            $("li.donation-level > input.level-element").addClass('notActive');   

            $("li.donation-level > button.level-element").removeClass('notActive');
            $("li.donation-level > button.level-element").not('.active').addClass('notActive');
        });

        $(document).on("click", "input.level-element", function() {    
            $("li.donation-level > input.level-element").removeClass('notActive');   
            $("li.donation-level > input.level-element").addClass('active'); 

            $("li.donation-level > button.level-element").addClass('notActive');
            $("li.donation-level > button.level-element").removeClass('active');
        });
    });

    $(window).bind("load", function () { 
        SetOffsetFormHonoreeData();
    });

    $('.donate-form-wrapper').on("click", function () {
        SetOffsetFormHonoreeData();
    });

    function SetOffsetFormHonoreeData() {
        var offsetTopSteps = $(".designations-steps").offset().top;
        var offsetTopForm = $(".in-memory-of").offset().top;
        var heightForm = $(".in-memory-of").height();
        var marginTopForm = parseInt($(".in-memory-of").css('margin-top'));
        var paddingTopForm = parseInt($(".in-memory-of").css('padding-top'));

        var correctOffsetForm = offsetTopForm + marginTopForm + paddingTopForm + heightForm;       
        honoreForm.css("margin-top",offsetTopSteps - correctOffsetForm);
    }

    giftInMemoryOf.on('click', function () {
        Tracker.donationFormHonorMemoryOfOpened({ formId: formID });
        honoreeData.toggle();
    });
    inHonorOf.on('change', function () {
        $(this).addClass('checked');
        inMemoryOf.removeClass('checked');
        tributeType = $(this).val();
    });
    inMemoryOf.on('change', function () {
        $(this).addClass('checked');
        inHonorOf.removeClass('checked');
        tributeType = $(this).val();
    });
    honoreeNext.on('click', function () {
        if (!validateHonoree()) { return; }
        Tracker.donationFormHonorMemoryOfSubmit({
            formId: formID,
            inHonorSelected: $('#honoree').val() && tributeType === 'tribute',
            inMemorySelected: $('#honoree').val() && tributeType === 'memorial',
        })
        switchScreen(SCREENS.PAYMENT_INFO);
    });    

    previous1.on('click', function () {
        Tracker.donationFormBackButtonClick({ formId: formID, step: currentScreen });
        switchScreen(SCREENS.DONATION_LEVEL);
    });
    previous2.on('click', function () {
        Tracker.donationFormBackButtonClick({ formId: formID, step: currentScreen });
        switchScreen(SCREENS.PAYMENT_INFO);
    });

    cancelButton1.add(cancelButton2).on('click', function () {
        Tracker.donationFormCancelButtonClick({ formId: formID, step: currentScreen });
        switchScreen(SCREENS.DONATION_LEVEL);
    });

    $(document).on('click', function (event) {
        if (!$(event.target).closest(honoreeData).length && !$(event.target).closest(giftInMemoryOf).length) {
            honoreeData.css('display', 'none');
        }
        if(designationsList.css('display') !== 'none') {
            designationsList.css('display', 'none');
        }
    });

    nextButton.on('click', function (evt) {
        evt.stopPropagation();
        errorField[0].innerHTML = '';
        let validationResult = donationLevels.validate();
        if (!validationResult.valid) {
            errorField[0].innerHTML = validationResult.message;
            scrollToFormTop();
            return;
        }

        switchScreen(SCREENS.PAYMENT_INFO);
        // Live ticket 422919, second step
        window['optimizely'] = window['optimizely'] || [];
        window['optimizely'].push({
            type: "event",
            eventName: "jnf_2_donations_step_2",
            tags: {
                revenue: 0, // Optional in cents as integer (500 == $5.00)
                value: 0.00 // Optional as float
            }
        });
    });
    billingNextButton1.on('click', function () {
        if (!paymentInfo.validateCardData()) { return; }
        switchScreen(SCREENS.BILLING_INFO);

        // Live ticket 422919, third step
        window['optimizely'] = window['optimizely'] || [];
        window['optimizely'].push({
            type: "event",
            eventName: "jnf_2_donations_step_3",
            tags: {
                revenue: 0, // Optional in cents as integer (500 == $5.00)
                value: 0.00 // Optional as float
            }
        });
    });
    goBackButton.on('click', function () {
        switchScreen(SCREENS.DONATION_LEVEL);
    });

    $('select').change(function () {
        $(this).addClass('selected');
    });

    form.find('[data-preview]').click(function (e) {
        e.preventDefault();
        switchScreen(this.dataset.preview);
    });

    donateButton.on('click', function () {
        if (sendingRequest || !billingInfo.validate()) {
            return;
        }
        
        let donateBtn = $(this);
        sendingRequest = true;
        $(this).html('<i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>').addClass('sending-request');

        let selectedPaymentMethod = paymentInfo.getSelectedPaymentMethod();
        
        let donationDuration = 0;
        let honoreeName = $('#honoree').val();
        let notifyTitle = $('#honoree-title').val();
        let notifyFirstName = $('#honoree-first-name').val();
        let notifyLastName = $('#honoree-last-name').val();
        let notifyStreetAddress1 = $('#honoree-street-address-1').val();
        let notifyStreetAddress2 = $('#honoree-street-address-2').val();
        let notifyCity = $('#honoree-city').val();
        let notifyState = $('#honoree-state').val();
        let notifyZipCode = $('#honoree-zip-code').val();
        let notifyCountry = $('#honoree-country').val();
        
        $(this).html('<i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>').addClass('sending-request');

        let billingData = billingInfo.getDonateRequestData();
        let donationData = _.assign({
            'sustaining.frequency': donationFrequency,
            'sustaining.duration': donationDuration,
            'method': selectedPaymentMethod == PaymentMethods.CARD ? 'donate' : 'startDonation',
            'api_key': luminateClientApiConfig.ApiKey,
            'form_id': formID,
            'v': luminateClientApiConfig.Version,
            'response_format': 'json',
            'tribute.honoree.name.full': honoreeName,
            'shipping.name.first': notifyFirstName,
            'shipping.name.last': notifyLastName,
            'shipping.address.title': notifyTitle,
            'shipping.address.street1': notifyStreetAddress1,
            'shipping.address.street2': notifyStreetAddress2,
            'shipping.address.city': notifyCity,
            'shipping.address.zip': notifyZipCode,
            'shipping.address.state': notifyState,
            'shipping.address.country': notifyCountry,
            'tribute.type': tributeType,
            'source': params.s_src,
            'sub_source': params.sub_src,
            'is_amount_predefined': donationLevels.isSelectedLevelPredefined(),
        }, donationLevels.getDonateRequestData(), billingData, paymentInfo.getDonationRequestData());
        
        //for testing purposes only
        if (window.location.hostname === 'localhost') { donationData['df_preview'] = true; }

        $.ajax({
            type: 'POST',
            url: `${luminateClientApiConfig.BaseUrl}CRDonationAPI`,
            data: donationData,
            xhrFields: { withCredentials: true },
            success: function (response) {
                let responseObject = JSON.parse(response);

                if (selectedPaymentMethod == PaymentMethods.CARD) {
                    sendingRequest = false;
                    donateBtn.html('DONATE').removeClass('sending-request');

                    const id = responseObject.donationResponse.donation.transaction_id;
                    finishDonation(id, donationData, responseObject)
                    
                } else {

                    const repository = new DonationDetailsRepository(window.sessionStorage);

                    repository.set(donationId, donationData);
                    window.location.href = responseObject.donationResponse.redirect.url;
                }
            },
            error: function (error) {
                let errorWithoutNewLines = error.responseText.replace(/(\r\n|\n|\r)/gm, "");
                let errorObject = JSON.parse(errorWithoutNewLines);
                let errorMessage = errorObject.donationResponse.errors.pageError;
                errorField.html(errorMessage);
                sendingRequest = false;
                            
                donateBtn.html('DONATE').removeClass('sending-request');
                if (errorObject.donationResponse.errors.code == 135) {
                    billingForm2.css('display', 'none');
                    billingForm1.css('display', 'block');
                    $('#expiration-month').after('<p class="required-warning">required field</p>').css('border', '1px solid red');
                }
                else if (errorObject.donationResponse.errors.code == 136) {
                    billingForm2.css('display', 'none');
                    billingForm1.css('display', 'block');
                    $('#expiration-year').after('<p class="required-warning">required field</p>').css('border', '1px solid red');
                }
                else if (errorObject.donationResponse.errors.code == 134) {
                    billingForm2.css('display', 'none');
                    billingForm1.css('display', 'block');
                }
            }
        });
    });

    printThankYouPage.on('click', function () {
        Tracker.donationFormPrintClick();
        window.print();
    });

    function hideLoadingOverlay() {
        let overlay = form.find('.loading-overlay');
        overlay.css('opacity', 0);
        overlay.css('visibility', 'hidden');
    }

    let scrollOffset = 160;
    function validateHonoree() {
        $('p.required-warning').remove();
        if (honoreeInputField.val().length < 1) {

            $('html, body').animate({
                scrollTop: giftInMemoryOf.offset().top - scrollOffset
            }, 500);
            honoreeInputField.after('<p class="required-warning">required field</p>').css('border', '1px solid red');
            return false;
        }
        makeSelectionWindow.removeClass('required-warning');
        return true;
    }

    

    function scrollToFormTop() {
        $('html, body').animate({
            scrollTop: form.offset().top - scrollOffset
        }, 500);
    }

    function switchScreen(screenType) {
        selectDonateForm.css('display', screenType === SCREENS.DONATION_LEVEL ? 'block' : 'none');
        billingForm1.css('display', screenType === SCREENS.PAYMENT_INFO ? 'block' : 'none');
        billingForm2.css('display', screenType === SCREENS.BILLING_INFO ? 'block' : 'none');
        successMessage.css('display', screenType === SCREENS.SUMMARY ? 'block' : 'none');
        donationFormPicture.css('display', screenType !== SCREENS.SUMMARY ? 'block' : 'none');
        $(window).scrollTop($('.fill-donate-form-wrapper:visible').offset().top);

        currentScreen = screenType;
        if (currentScreen === SCREENS.PAYMENT_INFO) { onPaymentScreenOpen(); }

        const virtualPath = `${window.location.pathname}/${screenType}`;
        Tracker.trackVirtualPageView({ virtualPath });
    }

    function onPaymentScreenOpen() {
        Tracker.donationFormPaymentScreenOpen({
            formId: formID,
            designate: donationLevels.designationName,
            donationAmount: donationLevels.selectedAmount,
            preselectedAmoutChosen: donationLevels.isSelectedLevelPredefined(),
            donationType: donationFrequency || 'once',
            inHonorSelected: Boolean($('#honoree').val()) && tributeType === 'tribute',
            inMemorySelected: Boolean($('#honoree').val()) && tributeType === 'memorial',
        })
    }

    function finishDonation(id, donationData, responseObject) {
        new ThankYouMessage({
            $element: $('.jnf-widget.jnf-widget-full-donation.thank-you-message'),
            donationData: donationData,
            responseObject
        });

        switchScreen(SCREENS.SUMMARY);
        const donationFrequency = donationData["sustaining.frequency"] || "once";
        const tributeHonoreeName = donationData["tribute.honoree.name.full"];
        const tributeType = donationData["tribute.type"];

        Tracker.donationFormPaymentSuccess({
            formId: donationData["form_id"],
            designate: donationData["designation.name"],
            donationAmount: donationData["other_amount"],
            donationType: donationFrequency || 'once',
            inHonorSelected: tributeHonoreeName && tributeType === 'tribute',
            inMemorySelected: tributeHonoreeName && tributeType === 'memorial',
            preselectedAmoutChosen: donationData["is_amount_predefined"],
            ecommerce: {
                purchase: {
                    products: [{
                        name: `$${donationData["other_amount"]}`,
                        price: parseFloat(donationData["other_amount"]),
                        quantity: 1,
                    }],
                    actionField: {
                        revenue: parseFloat(donationData["other_amount"]),
                        id: `${id}`
                    }
                }
            }
        });

        $('.start-campaign').on('click', () => Tracker.donationFormStartCampaignClick());
        $('.share-start-campaign-buttons').find('.jssocials-share-link, .facebook-share-button')
            .on('click', () => Tracker.donationFormSocialButtonClick());
    }
}